// extracted by mini-css-extract-plugin
module.exports = {"tokenInput":"token-input__tokenInput","input":"token-input__input"};